import { protocolBrandPath } from '@hub/common';
import { storageObjectUrl } from 'features/firebase/storageObjectUrl';

/** The public download URL of a protocol's brand copy. */
export const protocolBrandUrl = (protocolId: string): string =>
  storageObjectUrl(protocolBrandPath(protocolId));
